import React from 'react';
import { ENV } from 'constants/env';
import { cn } from 'lib/utils';
import { useYBugApi } from 'modules/app/YBugContext';
import { Button } from 'components/ui/button';
import { CircleHelp } from 'lucide-react';
import { SUPPORT_EMAIL } from '../../constants';

interface YBugFloatingButtonProps {
  position?: 'right' | 'left' | 'top';
  style?: React.CSSProperties;
}

const YBugFloatingButton: React.FC<YBugFloatingButtonProps> = ({
  position = 'right',
  style = {},
}) => {
  const yBugApi = useYBugApi();

  const isYBugAvailable = yBugApi && ENV.VITE_YBUG_ID;

  const handleSupport = () => {
    // If YBug is available, open the feedback form
    if (isYBugAvailable) {
      // Use the default 'open()' method without specifying 'feedback'
      // This shows the initial selection modal instead of the full form
      yBugApi?.open();
    } else {
      // Otherwise, as an alternative, trigger an email to the support team
      window.location.href = `mailto:${SUPPORT_EMAIL}?subject=Report an Issue`;
    }
  };

  const positionStyles = {
    left: 'left-[25px]',
    right: 'right-[25px]',
    top: 'top-[15px] right-[25px] bottom-0',
  };

  return (
    <Button
      variant="default"
      size="icon"
      onPointerDown={(e) => e.stopPropagation()}
      className={cn(
        'pointer-events-auto fixed bottom-[25px] z-[9999999999] h-12 w-12 rounded-full',
        'shadow-md transition-all duration-300 hover:shadow-lg',
        'hover:scale-[1.08] active:scale-[0.96]',
        positionStyles[position]
      )}
      style={style}
      aria-label="Support"
      onClick={handleSupport}
    >
      <CircleHelp data-testid="support-dropdown-menu-icon" size={32} />
    </Button>
  );
};

export default YBugFloatingButton;
